









import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

import AboutHelperComponents2Header from './about-helper-components-2-header.vue'
import AboutHelperComponents3ResourceList from './about-helper-components-3-resource-list.vue'

@Component({
  components: {
    AboutHelperComponents2Header,
    AboutHelperComponents3ResourceList
  }
})
class AboutHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean
}
export default AboutHelperComponents1MainPage
